<span class="d-flex align-items-center txt-value">
  @if ((orcidUrl$ | async)) {
    <a href="{{(orcidUrl$ | async)}}/{{metadataValue}}" target="_blank">
      {{ metadataValue }}
    </a>
  } @else {
    {{ metadataValue }}
  }


  @if (hasOrcidBadge()) {
    <img
      placement="top"
      ngbTooltip="{{ 'orcid.badge.tooltip' | translate }}"
      class="orcid-icon"
      alt="orcid-logo"
      src="assets/images/orcid.logo.icon.svg"/>
  }

</span>
